import { AppShell, Container, Group, Text, useMantineTheme } from '@mantine/core';

import { PRIMARY_FONT } from '../../constants/fonts';
import { NavigationMenu } from '../Navigation';
import { ScrollToTop } from '../Navigation/ScrollToTop';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const theme = useMantineTheme();
  
  return (
    <AppShell
      header={{ height: 80 }}
      styles={{
        header: {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid var(--mantine-color-gray-2)',
        },
      }}
    >
      <AppShell.Header>
        <Container size="lg" h="100%">
          <Group h="100%" justify="space-between" align="center">
            <Text
              size="xl"
              fw={600}
              style={{
                fontFamily: PRIMARY_FONT,
                color: theme.other.titleColor,
                cursor: 'pointer',
              }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Ula & Dawid
            </Text>
            <NavigationMenu />
          </Group>
        </Container>
      </AppShell.Header>

      <AppShell.Main>
        {children}
        <ScrollToTop />
      </AppShell.Main>
    </AppShell>
  );
};

export { AppLayout };
export default AppLayout;
